import React from 'react';

const crossPlatformCards = [
  {
    id: 'shopify-seo',
    title: 'Shopify SEO',
    description:
      'Our Shopify SEO services can be so profitable for your e commerce business. We optimize your products, categories, update schema markup, and add more efforts to get your store visible and rank higher in the search results.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
        <path d="M3 6h18" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <rect x="25" y="30" width="50" height="46" rx="8" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <path d="M38 30V22C38 15.3726 43.3726 10 50 10C56.6274 10 62 15.3726 62 22V30" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <circle cx="50" cy="52" r="8" stroke="#c40a0a" strokeWidth="2.5" />
        <path d="M42 66H58" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" />
        <path d="M15 88L30 88L40 78L60 88L70 78L85 88" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'ecommerce-seo',
    title: 'eCommerce SEO',
    description:
      'It is important to know who is interested in your business if you want your social media campaign to truly succeed. Our team carefully monitors every social platform where your brand appears, giving you insight into who’s talking about you, what they’re saying, and how you can keep your brand at the center of the conversation. By monitoring these insights, we evolve campaigns accordingly to drive targeted results.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8" cy="21" r="1" />
        <circle cx="19" cy="21" r="1" />
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <circle cx="42" cy="75" r="5" stroke="#c40a0a" strokeWidth="3" />
        <circle cx="72" cy="75" r="5" stroke="#c40a0a" strokeWidth="3" />
        <path d="M20 25H30L38 60H78L86 35H32" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M50 45L58 35L66 45" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M58 35V52" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M15 88L30 88L40 78L60 88L70 78L85 88" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'magento-seo',
    title: 'Magento SEO',
    description:
      'With our expert SEO services, we work on every aspect of your Magento website and make sure to improve your ranking in search engine results, which makes your business earn money without lacking.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="m18 2 4 4-12 12H6v-4L18 2z" />
        <path d="M3 20h18" />
        <path d="M7 16v4" />
        <path d="M11 12v8" />
        <path d="M15 8v12" />
        <path d="m14 5 3-3 3 3" />
        <path d="M17 2v10" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <rect x="22" y="52" width="12" height="24" rx="2" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <rect x="42" y="38" width="12" height="38" rx="2" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <rect x="62" y="24" width="12" height="52" rx="2" stroke="#c40a0a" strokeWidth="3" fill="rgba(196, 10, 10, 0.12)" />
        <path d="M56 22L68 10L80 22" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M68 11V30" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <path d="M15 88L30 88L40 78L60 88L70 78L85 88" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

function CrossPlatformSeoSection() {
  return (
    <section className="cross-platform-seo-section">
      <div className="container">
        {/* Section Header */}
        <div className="cross-platform-seo-header">
          <h2 className="cross-platform-seo-title">
            Cross-Platform <span className="seo-red-title">SEO Services</span> In Pakistan
          </h2>
          <p className="cross-platform-seo-subtitle">
            Get More Traffic, More Leads, More Revenue
          </p>
        </div>

        {/* 3 White Feature Cards Grid */}
        <div className="cross-platform-seo-grid">
          {crossPlatformCards.map((card) => (
            <div key={card.id} className="cross-platform-card">
              <div className="cross-platform-card-icon">
                {card.icon}
              </div>

              <h3 className="cross-platform-card-title">
                {card.title}
              </h3>

              <p className="cross-platform-card-desc">
                {card.description}
              </p>

              {/* Corner Animated Graphic emerging on hover */}
              <div className="cross-platform-corner-wrapper">
                {card.cornerSvg}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CrossPlatformSeoSection;
